interface LogoProps {
  variant?: 'full' | 'icon';
  className?: string;
}

export function Logo({ variant = 'full', className = '' }: LogoProps) {
  if (variant === 'icon') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className={`w-8 h-8 ${className}`}>
        <rect width="32" height="32" rx="7" fill="#f39c12" />
        <text
          x="16" y="19"
          textAnchor="middle"
          fontFamily="'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif"
          fontSize="16" fontWeight="600"
          fill="#ffffff"
          letterSpacing="-0.8px"
        >fb</text>
      </svg>
    );
  }

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="w-8 h-8 shrink-0">
        <rect width="32" height="32" rx="7" fill="#f39c12" />
        <text
          x="16" y="19"
          textAnchor="middle"
          fontFamily="'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif"
          fontSize="16" fontWeight="600"
          fill="#ffffff"
          letterSpacing="-0.8px"
        >fb</text>
      </svg>
      <span className="text-lg leading-tight" style={{ letterSpacing: '-0.5px' }}>
        <span className="font-semibold text-default">Flow</span>
        <span className="font-light text-muted">Board</span>
      </span>
    </div>
  );
}
